import { render, staticRenderFns } from "./ProcessAbout.vue?vue&type=template&id=b5d35c16&"
import script from "./ProcessAbout.vue?vue&type=script&lang=js&"
export * from "./ProcessAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports